module.exports = __webpack_public_path__ + "static/img/bg_jp.2337f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/bg_jp.png
// module id = F4qc
// module chunks = 1